import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import highlightSearchTerm from './highlightSearchTerm'

const SuggestionsListItem = props => {
  const {
    styles,
    focusedIndex,
    inputValue,
    onMenuClick,
    handleMenuMouseEnter,
    handleMenuMouseLeave,
    index,
    suggestion,
    showSeparator
  } = props

  return (
    <li
      className={classNames(styles.listItem, {
        [styles.focusedListItem]: focusedIndex === index,
        [styles.separator]: showSeparator
      })}
      onMouseDown={event => onMenuClick(suggestion, event)}
      onMouseEnter={() => handleMenuMouseEnter(index)}
      onMouseLeave={() => handleMenuMouseLeave(index)}
    >
      <a
        className="fds-c-text-link -color-dark -decoration-none"
        href={suggestion.link}
      >
        <span className={classNames(styles.suggestionText, 'h-text-truncate')}>
          <span
            dangerouslySetInnerHTML={{
              __html: highlightSearchTerm(
                suggestion.text,
                inputValue.trim(),
                styles
              )
            }}
          />
          {suggestion.category && (
            <span
              className={classNames(styles.categoryText, 'h-text-truncate')}
            >
              in {suggestion.category}
            </span>
          )}
        </span>
      </a>
    </li>
  )
}

SuggestionsListItem.propTypes = {
  suggestion: PropTypes.object,
  styles: PropTypes.object,
  focusedIndex: PropTypes.number,
  inputValue: PropTypes.string,
  onMenuClick: PropTypes.func,
  handleMenuMouseEnter: PropTypes.func,
  handleMenuMouseLeave: PropTypes.func,
  index: PropTypes.number,
  showSeparator: PropTypes.bool
}

export default SuggestionsListItem



// WEBPACK FOOTER //
// ./client/components/autosuggest/suggestionsListItem.js